// Schedules.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import moment from 'moment';
import config from '../config';
import './schedule-ui.css';

import i18n from "../i18n";
const tr = i18n.t.bind(i18n);
const Schedules = ({ closeModal }) => {

  const [slots, setSlots] = useState([]);
  const [editingSlots, setEditingSlots] = useState([]);
  const [categories, setCategories] = useState([]);
  const [changes, setChanges] = useState(false);
  const [areas, setAreas] = useState([]);

  useEffect(() => {
    // Fetch schedules
    axios.get(tr('{{API_BASE_URL}}/schedules', {
      API_BASE_URL: config.API_BASE_URL
    }))
      .then(res => {
        setSlots(res.data);
        setEditingSlots(res.data.map(slot => ({
          id: slot.id,
          role: slot.role,
          day: slot.day,
          area: slot.area,
          starts: slot.starts,
          ends: slot.ends
        })));
      });

    // Fetch user roles dynamically
    axios.get(tr('{{API_BASE_URL}}/users/roles', {
      API_BASE_URL: config.API_BASE_URL
    }))
      .then(res => {
      const roles = res.data.map(role => ({
        id: role.id,
        name: role.name,
        role: role.id,
        area: null
      }));

      // Fetch areas dynamically
      axios.get(tr('{{API_BASE_URL}}/areas', {
        API_BASE_URL: config.API_BASE_URL
      }))
        .then(res => {
          setAreas(res.data);
          setCategories(prevCategories => [
            ...roles,
            ...res.data.map(area => ({
              id: area.id,
              name: area.name,
              role: 'at_service',
              area: area.id
            }))
          ]);
        });
    });
  }, []);

  const handleAddSlot = (role, day, areaId = null) => {
    const existingSlots = editingSlots.filter(slot => slot.area === areaId && slot.role === role && slot.day === day);
    const starts = existingSlots.length ? existingSlots[existingSlots.length - 1].ends : '10:00';
    const ends = moment(starts, 'HH:mm').add(8, 'hours').format('HH:mm');
    setEditingSlots([...editingSlots, { role, day, area: areaId, starts, ends }]);
    setChanges(true);
  };

  const handleSaveAll = async () => {
    const res = await axios.post(tr('{{API_BASE_URL}}/schedules/bulk', {
      API_BASE_URL: config.API_BASE_URL
    }), editingSlots);
    setSlots([...slots, ...res.data.newSlots]);
    setChanges(false);
  };

  const handleDeleteSlot = async (index) => {
    const slotToDelete = editingSlots[index];
    if (slotToDelete.id) {
      await axios.delete(tr('{{API_BASE_URL}}/schedules/{{id}}', {
        API_BASE_URL: config.API_BASE_URL,
        id: slotToDelete.id
      }));
    }
    setEditingSlots(editingSlots.filter((_, i) => i !== index));
  };

  const handleDeleteAllSlots = async () => {
    if(window.confirm('You want to clear all slots from schedule?')){
      const deleteRequests = editingSlots
        .filter(slot => slot.id)
        .map(slot => {
        return axios.delete(tr('{{API_BASE_URL}}/schedules/{{id}}', {
          API_BASE_URL: config.API_BASE_URL,
          id: slot.id
        }));
      });
      await Promise.all(deleteRequests);
      setEditingSlots([]);
    }
  };

  const unsaved = changes;
  const slotCount = editingSlots.length;

  return (
    <div className="slot-modal-bg" onClick={() => { if (!unsaved) closeModal(); }}>
      <div className="slot-modal" onClick={(e) => e.stopPropagation()}>

        <div className="slot-modal-head">
          <div style={{ flex: 1 }}>
            <h3>⚙ {tr('Manage Weekly Schedule Slots')}</h3>
            <div className="sub">
              {tr('Define the recurring shift windows. They repeat every week — you assign people in the Scheduler.')}
            </div>
          </div>
          {unsaved && <span className="slot-unsaved">● {tr('Unsaved changes')}</span>}
          <button className="sch-btn ghost" style={{ fontSize: 20, padding: '4px 10px' }}
            onClick={() => {
              if (!unsaved || window.confirm(tr('You have unsaved changes. Discard them and close?'))) closeModal();
            }}>×</button>
        </div>

        <div className="slot-modal-body">
          <div className="sch-table-wrap" style={{ border: 'none' }}>
            <table className="sch-table" style={{ minWidth: 820 }}>
              <thead>
                <tr>
                  <th className="sch-rowhead">{tr('Role / Area')}</th>
                  {[...Array(7)].map((_, i) => (
                    <th key={i}>
                      <span className="dow">{moment().isoWeekday(i + 1).format('ddd')}</span>
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {categories.map((category, idx) => (
                  <tr key={idx}>
                    <td className="sch-rowhead">
                      {category.name}
                      {category.area ? <span className="sub">{tr('Area')}</span> : null}
                    </td>
                    {[...Array(7)].map((_, day) => (
                      <td key={day} className="slot-cell">
                        {editingSlots.map((slot, index) => (
                          (slot.day === day &&
                            ((category.area != null && slot.area === category.area) ||
                             (category.area == null && slot.area == null && slot.role === category.id)))
                            ? (
                              <div key={index} className="slot-chip">
                                <input type="time" value={slot.starts}
                                  onChange={(e) => {
                                    const u = [...editingSlots];
                                    u[index].starts = e.target.value;
                                    setEditingSlots(u); setChanges(true);
                                  }} />
                                <span className="dash">–</span>
                                <input type="time" value={slot.ends}
                                  onChange={(e) => {
                                    const u = [...editingSlots];
                                    u[index].ends = e.target.value;
                                    setEditingSlots(u); setChanges(true);
                                  }} />
                                <button className="del" title={tr('Remove Slot')}
                                  onClick={() => handleDeleteSlot(index)}>×</button>
                              </div>
                            ) : null
                        ))}
                        <button className="slot-add" title={tr('Add Slot')}
                          onClick={() => handleAddSlot(category.id, day, category.area)}>+</button>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="slot-modal-foot">
          <button className="sch-btn" disabled={slotCount === 0}
            style={{ color: slotCount ? '#dc2626' : undefined, borderColor: slotCount ? '#fecaca' : undefined }}
            onClick={handleDeleteAllSlots}>🗑 {tr('Delete All')}</button>
          <span className="sch-spacer" />
          <span style={{ color: '#6b7280', fontSize: 13 }}>
            {slotCount} {slotCount === 1 ? tr('slot') : tr('slots')}
          </span>
          <button className="sch-btn" onClick={() => {
            if (!unsaved || window.confirm(tr('You have unsaved changes. Discard them and close?'))) closeModal();
          }}>{tr('Close')}</button>
          <button className="sch-btn primary" disabled={!changes || slotCount === 0}
            style={!changes || !slotCount ? { opacity: .5 } : undefined}
            onClick={handleSaveAll}>💾 {tr('Save All')}</button>
        </div>
      </div>
    </div>
  );
};

export default Schedules;
